import * as React from "react";
import Input from "dt-design-system/es/input";
import Button from "dt-design-system/es/button";
import Dropdown from "dt-design-system/es/dropdown";
import PaxPlanForm from "./pax-plan-form";
import message from "./message";
import filtersCss from "./filters.module.css";
import css from "./pax-plan-input.module.css";

const getLabel = (lang, paxPlan) => {
  if (!paxPlan) return message(lang, "pax-plan-placeholder");
  const { adults, children } = paxPlan;
  const adultsLabel =
    adults &&
    `${adults} ${
      adults > 1
        ? message(lang, "pax-plan-adults")
        : message(lang, "pax-plan-adult")
    }`;
  const childrenLabel =
    children &&
    `${children} ${
      children > 1
        ? message(lang, "pax-plan-children")
        : message(lang, "pax-plan-child")
    }`;
  if (adultsLabel && childrenLabel) {
    return `${adultsLabel} ꔷ ${childrenLabel}`;
  } else if (adultsLabel && !childrenLabel) {
    return adultsLabel;
  } else if (childrenLabel && !adultsLabel) {
    return childrenLabel;
  }
  return "";
};

const PaxPlanInput = ({
  lang,
  align,
  paxPlan,
  setPaxPlan,
  scrollToFilters,
}) => {
  const ref = React.useRef(null);
  const dropdownRef = React.useRef(null);
  const [opened, setOpened] = React.useState(false);

  const toggleForm = () => {
    setOpened(!opened);
  };

  const closeOnOutsideClick = React.useCallback(
    (e) => {
      if (
        ref.current?.contains(e.target) ||
        dropdownRef.current?.contains(e.target)
      )
        return;
      setOpened(false);
    },
    [setOpened]
  );

  React.useEffect(() => {
    if (opened) {
      document.body.addEventListener("click", closeOnOutsideClick);
      return () =>
        document.body.removeEventListener("click", closeOnOutsideClick);
    }
  }, [closeOnOutsideClick, opened]);

  const label = getLabel(lang, paxPlan);
  const value = paxPlan ? label : "";

  return (
    <Dropdown
      ref={dropdownRef}
      title={message(lang, "pax-plan-label")}
      anchorRef={ref}
      breakpoint={600}
      onClose={setOpened}
      open={opened}
      content={
        <>
          <PaxPlanForm lang={lang} onChange={setPaxPlan} {...paxPlan} />
          <Button className={css.confirm} onClick={toggleForm}>
            {message(lang, "confirm")}
          </Button>
        </>
      }
      align={align}
    >
      <div ref={ref} className={filtersCss.filter}>
        <Input
          type="text"
          className={filtersCss.filter}
          icon={opened ? "ChevronUp" : "ChevronDown"}
          value={value}
          placeholder={label}
          onClick={toggleForm}
          onMouseUp={scrollToFilters}
          data-pax=""
          readOnly
        />
      </div>
    </Dropdown>
  );
};

export default PaxPlanInput;
